import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalTrialSaudeComponent } from 'src/app/components/banner-saude/dialogs/trial-saude/trial-saude.component';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  templateUrl: './trial.component.html',
  selector: 'menu-item-saude-trial',
})
export class MenuItemSaudeTrialComponent {
  private readonly apiUsuario = inject(ApiUsuarioService);
  private readonly appService = inject(AppService);
  private readonly dialog = inject(MatDialog);

  protected readonly isAdministrativo = this.apiUsuario.isUserAdmin();
  protected readonly isFilial = this.appService.isFilial();
  protected readonly referenciaMatriz = this.appService.referenciaAdministracaoMatriz();

  protected iniciarTeste() {
    this.dialog.open(ModalTrialSaudeComponent, { width: '550px' });
  }
}
